import { Spinner, Text } from '@chakra-ui/react'
import React from 'react'

export type TranscriptInProgressToolTipProps = {
  content: string | React.ReactNode
  isLoading?: boolean
}

export const TranscriptInProgressToolTip = ({
  content,
  isLoading = false,
}: TranscriptInProgressToolTipProps) => {
  return (
    <>{isLoading ? <Spinner size="lg" /> : <Text as="div">{content}</Text>}</>
  )
}
